<template>
  <form>
    <mdb-input label="사용자 ID*" v-model="user.userId"/>
    <mdb-btn icon="check" class="m-0 p-1" @click="isexist" > 중복체크 </mdb-btn>
    <div :class="{'red-text' : !idcheck}">{{checkMessage}}</div>
    <mdb-input label="이름*" v-model="user.name"/>
    <div> 성별:
      <label><input type="radio" v-model="user.gender" value="남"> 남</label>
      <label class="ml-3"><input type="radio" v-model="user.gender" value="여"> 여</label>
    </div>
    <mdb-input label="비밀번호*" type="password" v-model="user.password"/>
    <mdb-input label="비밀번호 확인*" type="password" v-model="password2"/>
    <mdb-input label="전화번호(010-xxxx-xxxx)"   class="w-60" v-model="cellphone"/>
    <mdb-input label="email*" type="email" v-model="user.email"/>
    <mdb-input label="주소" v-model="user.address"/>
    <div class="text-center">
      <mdb-btn icon="check" @click="$router.back()">돌아가기</mdb-btn>
      <mdb-btn icon="check" @click="onOk" :disabled="!isOk">확인</mdb-btn>
    </div>
  </form>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'ProfileJoin',
  components: { },
  props: ['user'],
  data: () => ({
    idcheck: false,
    cellphone: '',
    password2: '',
    checkMessage: 'ID 중복 체크를 해야 합니다.'
  }),
  computed: mapState({
    // article: state => state.board.article,
    isOk () {
      return this.user.userId && this.user.password && this.password2 && this.idcheck && this.user.name && this.user.email
    }
  }),
  methods: {
    ...mapMutations({ }),
    ...mapActions({ }),
    async isexist () {
      if (!this.user.userId) {
        return alert('사용자 ID를 입력하세요.')
      }
      const { exists } = await this.$Auth.isexist(this.user.userId)
      if (exists) {
        this.checkMessage = this.user.userId + '는 이미 사용 중인 ID입니다.'
      } else {
        this.checkMessage = '사용 가능한 ID입니다.'
      }
      this.idcheck = !exists
    },
    onOk () {
      if (this.user.password !== this.password2) {
        alert('비밀번호 확인이 다릅니다.')
        return
      }
      if (this.cellphone.trim()) {
        const numbers = this.cellphone.split('-')
        if (numbers.length !== 3) {
          return alert('전화번호 양식이 올바르지 않습니다.')
        }
        this.user.cellPhone = {
          number1: numbers[0],
          number2: numbers[1],
          number3: numbers[2]
        }
      }
      if (!confirm('저장할까요?')) return
      this.$emit('join', this.user)
    }
  }
}
</script>
